// STORAGE KEYS
export const FEEDS_LIST_STORAGE_KEY = 'ops-feeds-list';
export const FEEDS_LIST_VIEW_KEY = 'tv-ops-feeds-list';
